// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yD_Q","colBig":"styles_colBig__AfRtD","colSmall":"styles_colSmall__2R_dv"};